import React from 'react';
import * as styles from '../tanks.module.scss';
import { withRouter } from 'react-router-dom';
import { withTranslation, Trans } from 'react-i18next';
import tankService from '../../../services/tanksService';

const emptyArea = {
    areaId: 0,
    areaName: "",
    areaDescription: ""
}

class AddAreaView extends React.Component {
    constructor(props) {
        super(props);

        this.state = { item: Object.assign({}, emptyArea) };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        let newState = Object.assign({}, this.state);
        newState.item.areaName = this.refs.areaName.value;
        newState.item.areaDescription = this.refs.areaDescription.value;
        this.setState(newState);
        tankService.addAreaAsync(newState.item).then(() => this.props.history.goBack());        
    }

    cancel(e) {
        e.preventDefault();
        this.props.history.goBack();
    }

    render() {
        return (
            <div className="form_container">
                <form className="edit-card-form" onSubmit={this.handleSubmit}>
                    <div className="form-body">
                        <p>
                            <label><Trans>Tanks.areaName</Trans></label>
                            <input type="text" ref="areaName" defaultValue={this.state.item.areaName}/>
                        </p>
                        <p>
                            <label><Trans>Tanks.areaDescription</Trans></label>
                            <input type="text" ref="areaDescription" defaultValue={this.state.item.areaDescription}/>
                        </p>
                        <div className="form-buttons-container">
                            <button type="submit"><Trans>Table.saveButton</Trans></button>
                            <button onClick={this.cancel}><Trans>Table.cancelButton</Trans></button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

}

// function mapStateToProps(state, ownProps) {
//     return createStructuredSelector({
//         item: Object.assign({}, emptyArea)
//     });
// }

// const mapDispatch = (dispatch, ownProps) => {
//     return {
//         addArea: area => dispatch(actionTanks.addArea(area, ownProps))
//     };
// };

export default withRouter((withTranslation("translations")(AddAreaView)));